import { Typography, CircularProgress, Box, Grid } from '@mui/material';
import theme from 'theme';
import GoogleButton from 'react-google-button';

import { useAuth } from 'auth';

const SignIn = () => {
  const auth = useAuth();
  const { loading, signInError } = auth;

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        height: '100vh',
        textAlign: 'center',
      }}
    >
      <Grid sx={{ height: '100%', flexWrap: 'nowrap' }} container>
        <Grid
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            backgroundColor: '#2B6096',
            borderRadius: '1rem',
            margin: '1rem',
            width: '30.5rem',
            [theme.breakpoints.down('lg')]: {
              display: 'none',
            },
          }}
        >
          <Box
            sx={{
              backgroundColor: '#2B6096',
              width: '27.5rem',
              height: '27.5rem',
              backgroundImage: 'url(/images/oversight-img.png)',
              backgroundSize: 'cover',
              margin: '1.5rem',
            }}
          />
        </Grid>
        <Grid
          sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
          size={{
            lg: 8,
            xs: 12,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: theme.spacing(8),
              flexBasis: '700px',
              alignSelf: 'center',
              justifyContent: 'center',
              [theme.breakpoints.down('md')]: {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
              },
            }}
          >
            {loading ? (
              <>
                <Typography sx={{ marginTop: theme.spacing(3) }} variant="h4">
                  Loading...
                </Typography>
                <Box
                  sx={{
                    marginTop: theme.spacing(2),
                    color: theme.palette.text.secondary,
                    display: 'flex',
                    alignSelf: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CircularProgress />
                </Box>
              </>
            ) : (
              <>
                <Box
                  sx={{
                    height: theme.spacing(5.25),
                    width: theme.spacing(5.25),
                    backgroundImage: 'url(/images/logo.svg)',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    marginLeft: theme.spacing(15.25),
                  }}
                />
                <Typography sx={{ marginTop: theme.spacing(3) }} variant="h4">
                  Sign In
                </Typography>
                <Typography
                  sx={{ color: theme.palette.text.secondary, marginTop: theme.spacing(0.5) }}
                  variant="body1"
                >
                  Please use ProductDock Google account.
                </Typography>
                <Box
                  sx={{
                    marginTop: theme.spacing(2),
                    color: theme.palette.text.secondary,
                    display: 'flex',
                    alignSelf: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <GoogleButton onClick={auth.signIn} />
                </Box>
                {signInError && (
                  <Typography
                    sx={{ color: theme.palette.error.main, marginTop: theme.spacing(2) }}
                    variant="body2"
                  >
                    {signInError.message}
                  </Typography>
                )}
              </>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SignIn;
